// extracted by mini-css-extract-plugin
export var wrapper = "SliderButton-module--wrapper--5441e";
export var arrow = "SliderButton-module--arrow--ede10";